import React, { useMemo } from "react";
import CustomModalLayout from "../../../../web/Auth/CustomModalLayout";
import BidHistoryCard from "./BidHistoryCard";
import { useSelector } from "react-redux";

interface BidsHistoryModalProps {
  app?: "bidder" | "banker" | "others" | false;
  open: boolean;
  setOpen: any;
  bidsEvent: any;
  wrongBidsEvent: any;
  isSwissAuction: boolean;
}
export default function BidHistoryModel({
  app,
  open,
  setOpen,
  bidsEvent,
  wrongBidsEvent,
  isSwissAuction = false,
}: BidsHistoryModalProps) {
  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });
  const onboardingData = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });
  const allBids = useMemo(() => {
    if (!bidsEvent.length && !wrongBidsEvent.length) return [];

    return [...bidsEvent, ...wrongBidsEvent]
      .filter((bid) => bid.bid_timestamp)
      .map((bid) => ({
        ...bid,
        status: wrongBidsEvent.includes(bid) ? "Failed" : "Success",
      }))
      .sort((a, b) => {
        return b.bid_timestamp - a.bid_timestamp;
      });
  }, [bidsEvent, wrongBidsEvent]);
  return (
    <CustomModalLayout
      open={open}
      onClose={() => setOpen(false)}
      childrenClassName="pb-0 px-4"
      className="pt-4 lg:pb-[30px] w-full mx-4 max-w-[650px]"
    >
      <div className="text-sm font-openSans text-brand-textBlack font-semibold">
        Bid History
      </div>
      <div className="mt-4 max-h-[400px] overflow-y-auto show-scrollbar">
        {allBids.map((bid, index) => (
          <BidHistoryCard
            isSwissAuction={isSwissAuction}
            // key={`BidHistoryCard_2_${index}`}
            // typeOfBid="user"
            // bidsTagText="Your bid has place successful" //Your bid has failed,New bid placed
            // bidsPrice={2000000}
            // bidTimestamp={Date.now()}
            // showStatus={true}
            // bidsStatusText="Success"
            // userName="r"
            // <BidHistoryCard
            key={`BidHistoryCard_${index}`}
            typeOfBid={
              app === "banker"
                ? "others"
                : bid?.user_uuid === user?.uuid
                ? "user"
                : "others"
            }
            bidsPrice={bid.bidding_amount}
            bidTimestamp={bid.frontend_timestamp}
            showStatus={false}
            bidsStatusText={bid.status}
            userName={onboardingData?.name}
            bidData={bid}
            app={app}
            index={index}
            // />
          />
        ))}
        {/* <BidHistoryCard
          typeOfBid="user"
          bidsTagText="Your bid has place successful" //Your bid has failed,New bid placed
          bidsPrice={2000000}
          bidTimestamp={Date.now()}
          showStatus={true}
          bidsStatusText="Success"
          userName="r"
        />
        <BidHistoryCard
          typeOfBid="user"
          bidsTagText="Your bid has failed" //Your bid has failed,New bid placed
          bidsPrice={1900000}
          bidTimestamp={Date.now()}
          showStatus={true}
          bidsStatusText="Failed"
          userName="r"
        />
        <BidHistoryCard
          typeOfBid="others"
          bidsTagText="New bid placed" //Your bid has failed,New bid placed
          bidsPrice={1800000}
          bidTimestamp={Date.now()}
          showStatus={true}
          bidsStatusText="Success"
        /> */}
      </div>
    </CustomModalLayout>
  );
}
